import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Headers, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { AuthService } from './auth.service';

import { environment } from '../../environments/environment';

@Injectable()
export class StmtService {

    apiUrl = environment.apiUrl;

    constructor(private http: Http,
        private authService: AuthService) { }

    getStatements(): Observable<any> {
        let token = 'Bearer ' + this.authService.getUserToken();
        let accountId = JSON.parse(localStorage.getItem('account') || '{}').id

        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);
        let params = new URLSearchParams();
        params.set('account', accountId);

        return this.http.get(this.apiUrl + '/statement', { headers: headers, params: params })
            .map(this.extractData)
            .catch(this.handleError);
    }

    getStatement(stmtId): Observable<any> {
        let token = 'Bearer ' + this.authService.getUserToken();

        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);

        return this.http.get(this.apiUrl + '/statement/' + stmtId, { headers: headers })
            .map(this.extractData)
            .catch(this.handleError);
    }

    deleteStatement(stmtId): Observable<any> {
        let token = 'Bearer ' + this.authService.getUserToken();

        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);

        return this.http.delete(this.apiUrl + '/statement/' + stmtId, { headers: headers })
            .map(this.extractData)
            .catch(this.handleError);
    }

    getOverview(): Observable<any> {
        let token = 'Bearer ' + this.authService.getUserToken();
        let accountId = JSON.parse(localStorage.getItem('account') || '{}').id

        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);
        let params = new URLSearchParams();
        params.set('account', accountId);

        return this.http.get(this.apiUrl + '/overview', { headers: headers, params: params })
            .map(this.extractData)
            .catch(this.handleError);
    }

    createStatement(newStmt): Observable<any> {
        let token = 'Bearer ' + this.authService.getUserToken();
        let accountId = JSON.parse(localStorage.getItem('account') || '{}').id

        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);
        let params = new URLSearchParams();
        params.set('account', accountId);
        params.set('month', newStmt.month);

        return this.http.put(this.apiUrl + '/statement', {}, { headers: headers, params: params })
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body;
    }

    private handleError(error: Response | any) {
        let errMsg: any;
        if (error instanceof Response) {
            errMsg = error.json();
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
}
